export default {
  name: "SplitButton",
  data: function data() {
    return {
      offset: true
    };
  },
  props: {
    mainAction: {
      type: Object,
      default: function _default() {
        return {
          label: "Action principale",
          disabled: false,
          handler: function handler() {}
        };
      }
    },
    dropdownActions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    hasActions: function hasActions() {
      return this.dropdownActions.length > 0;
    }
  }
};